// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filterSelector.ant-select-single .ant-select-selector {
    border-radius: 0px !important;
    height: 30px !important;
    background-color: #fdfefe !important;
    border: 1px solid #defbfb !important;
  }
.filterSelector.ant-select-selector{
    height: 30px !important;
    background-color: #fdfefe !important;
    border: 1px solid #defbfb !important;
}`, "",{"version":3,"sources":["webpack://./src/components/CheckSheet/ChecksheetDashboard/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,oCAAoC;IACpC,oCAAoC;EACtC;AACF;IACI,uBAAuB;IACvB,oCAAoC;IACpC,oCAAoC;AACxC","sourcesContent":[".filterSelector.ant-select-single .ant-select-selector {\n    border-radius: 0px !important;\n    height: 30px !important;\n    background-color: #fdfefe !important;\n    border: 1px solid #defbfb !important;\n  }\n.filterSelector.ant-select-selector{\n    height: 30px !important;\n    background-color: #fdfefe !important;\n    border: 1px solid #defbfb !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
